/**
 * Prefixes every id in inlined SVG markup, and each reference to one
 * (`href="#…"`, `url(#…)`), with `scope`. Two copies of a sticker on one
 * canvas would otherwise share ids, and a reference resolves to whichever
 * copy comes first in the document.
 */
export function scopeSvgIds(markup: string, scope: string): string {
  const safe = scope.replace(/[^A-Za-z0-9_-]/g, "_");
  const ids = new Set(
    Array.from(markup.matchAll(/\bid="([^"]+)"/g), (m) => m[1]),
  );
  if (ids.size === 0) return markup;
  const scoped = (id: string) => (ids.has(id) ? `${safe}-${id}` : id);
  return markup
    .replace(/\bid="([^"]+)"/g, (_, id: string) => `id="${scoped(id)}"`)
    .replace(
      /\b(href|xlink:href)="#([^"]+)"/g,
      (_, attr: string, id: string) => `${attr}="#${scoped(id)}"`,
    )
    .replace(/url\(#([^)]+)\)/g, (_, id: string) => `url(#${scoped(id)})`);
}
